@import 'styles/blaze/mixins';

.modalBody {
  width: 550px !important;
}

.header {
  display: flex;
  align-items: center;
}

.container {
  display: flex;
  flex-direction: column;
  gap: 20px;
}

.footer {
  align-items: center;
  display: flex;
  gap: 10px;
  justify-content: center;
}

.footerRightButtons {
  display: flex;
  gap: 4px;
}

.currentPlan,
.blackFridaySale {
  @include sm-sohne;

  background: var(--purple-70);
  border-radius: 16px;
  color: var(--light-100);
  line-height: 110%;
  padding: 4px 8px;
  position: absolute;
  left: 18px;
  top: -13px;
}

.blackFridaySale {
  background: var(--dark-80);
}
